function getIsPromoDate() {
  const currentDate = new Date();
  const startDate = new Date('2026-11-16');
  const endDate = new Date('2026-12-01');

  return currentDate >= startDate && currentDate <= endDate;
}

function getIsAcademyPromoDate() {
  const currentDate = new Date();
  const startDate = new Date('2026-07-09');
  const endDate = new Date('2026-07-27');

  return currentDate >= startDate && currentDate <= endDate;
}

function getIsTTCPromoDate() {
  const currentDate = new Date();
  const startDate = new Date('2026-05-04');
  const endDate = new Date('2026-05-15');

  return currentDate >= startDate && currentDate <= endDate;
}

// Cjenovni stupnjevi Akademije za predškolarce, poredani od najniže do najviše cijene.
export type AcademyPriceTier = 'promo' | 'reduced' | 'regular';

const ACADEMY_TIER_ORDER: AcademyPriceTier[] = ['promo', 'reduced', 'regular'];

// Datumi kada nova (viša) cijena stupa na snagu (Hrvatska ljetna vremenska zona, UTC+2).
const ACADEMY_REDUCED_START = new Date('2026-07-20T00:00:00+02:00'); // 159 EUR
const ACADEMY_REGULAR_START = new Date('2026-07-27T00:00:00+02:00'); // 199 EUR

function getActiveAcademyPriceTier(): AcademyPriceTier {
  const currentDate = new Date();

  if (currentDate >= ACADEMY_REGULAR_START) return 'regular';
  if (currentDate >= ACADEMY_REDUCED_START) return 'reduced';
  return 'promo';
}

// Stupanj je "istekao" kada je aktivan neki skuplji (kasniji) stupanj.
function isAcademyTierExpired(tier: AcademyPriceTier, activeTier: AcademyPriceTier): boolean {
  return ACADEMY_TIER_ORDER.indexOf(tier) < ACADEMY_TIER_ORDER.indexOf(activeTier);
}

const time = {
  getIsPromoDate,
  getIsAcademyPromoDate,
  getIsTTCPromoDate,
  getActiveAcademyPriceTier,
  isAcademyTierExpired,
};

export default time;
